import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./Destinations.css";
import goa from "../../assets/DOMESTIC DESTINATIONS/GOA IMAGE.webp";
import kerela from "../../assets/DOMESTIC DESTINATIONS/KERALA.webp";
import dubai from "../../assets/VISA REQUIRED DESTINATION/DUBAI.webp";
import paris from "../../assets/VISA REQUIRED DESTINATION/FRANCE.webp";

function Destinations() {
  const navigate = useNavigate();

  const domestic = [
    {
      name: "Goa",
      desc: "India’s beach paradise, famous for its golden shores, vibrant nightlife, Portuguese heritage, and laid-back vibe. From water sports and beach shacks to forts and flea markets, Goa offers the perfect blend of adventure and relaxation.",
      img: goa,
    },
    {
      name: "Kerala",
      desc: "Known as “God’s Own Country”, Kerala is blessed with serene backwaters, lush green hills, exotic wildlife, and pristine beaches. A perfect escape where nature, culture, and wellness come together for a truly rejuvenating experience.",
      img: kerela,
    },
  ];

  const international = [
    {
      name: "Dubai",
      desc: "A dazzling city where futuristic skyscrapers meet golden deserts and pristine beaches. Famous for luxury shopping, world-class attractions, and vibrant nightlife, Dubai is the ultimate blend of tradition and modernity.",
      img: dubai,
    },
    {
      name: "Paris",
      desc: "The City of Light, celebrated for its timeless romance, iconic landmarks, art, and haute couture. From the Eiffel Tower to charming cafés, Paris offers an unforgettable blend of culture, elegance, and charm.",
      img: paris,
    },
  ];

  const renderList = (list) =>
    list.map((item, index) => (
      <div
        key={index}
        className={`destination-item ${index % 2 === 0 ? "normal" : "reverse"}`}
      >
        <img src={item.img} alt={item.name} className="destination-img" />

        <motion.div
          className="destination-text"
          initial={{ opacity: 0, x: index % 2 === 0 ? 80 : -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h2 className="sub-headiing">{item.name}</h2>
          <p>{item.desc}</p>
        </motion.div>
      </div>
    ));

  return (
    <div className="destinations-page">
      <h1 className="main-heading">Destinations</h1>

      <h2 className="sub-heading">Domestic</h2>
      {renderList(domestic)}
      <button className="btn-explore" onClick={() => navigate("/packages")}>
        Explore More
      </button>

      <h2 className="sub-heading">International</h2>
      {renderList(international)}
      <button className="btn-explore" onClick={() => navigate("/packages")}>
        Explore More
      </button>
    </div>
  );
}

export default Destinations;
